import { useConfigStore } from "@stores/useConfigStore";
import React from "react";

export type CanEditProps = {
  hide?: boolean
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>
}

const BlockSection: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, style, ...wrapperProps }) => {
  return (
    <div
      style={
        {
          cursor: 'not-allowed',
          ...(style || {})
        }
      }
      {...wrapperProps}
    >
      <div
        style={
          {
            pointerEvents: 'none'
          }
        }
      >
        {children}
      </div>
    </div>
  )
}

export const CanEdit: React.FC<CanEditProps> = ({ hide = true, wrapperProps = {}, children }) => {
  const [
    canEdit
  ] = useConfigStore(
    (store) => [store.canEdit]
  )

  const blockEdit = hide ? <></> : <BlockSection {...wrapperProps}>{children}</BlockSection>

  return  canEdit() ? <>{children}</> : <>{blockEdit}</> 
}
